import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const NotFound = () => (
  <div className="min-h-screen bg-[#030303] flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
    <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_50%_40%,rgba(0,240,255,0.12),transparent_45%)]" />
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="relative">
      <h1 className="font-heading font-extrabold text-7xl sm:text-9xl tracking-tighter text-white text-glow">404</h1>
      <p className="text-white/60 mt-4 max-w-sm mx-auto">This scene didn't make the final cut. The page you're looking for doesn't exist.</p>
      <Link to="/" className="inline-block mt-8 rounded-full bg-[#00F0FF] text-black font-semibold px-8 py-3 hover:scale-105 transition-transform" data-testid="notfound-home">
        Back to Home
      </Link>
    </motion.div>
  </div>
);

export default NotFound;
